import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        d: "M20.77,14.22a11.13,11.13,0,0,1-3.67.7A6.39,6.39,0,0,1,13,13.6a.49.49,0,0,0-.79.25l-2,7a.5.5,0,0,0,0,.32c.18.45,3,1.78,4.62,1.78a11.56,11.56,0,0,0,4.36-1,.54.54,0,0,0,.29-.32l2-6.84a.51.51,0,0,0-.14-.51A.5.5,0,0,0,20.77,14.22Z",
        fill: "currentColor"
      }),
      _createElementVNode("path", {
        d: "M10.74,12.67a7.71,7.71,0,0,0-4.17-1.42,11.92,11.92,0,0,0-4.22,1,.47.47,0,0,0-.29.32L0,19.6a.5.5,0,0,0,.67.6,9.84,9.84,0,0,1,3.64-.83A6.45,6.45,0,0,1,8.09,20.7a.49.49,0,0,0,.28.09.47.47,0,0,0,.17,0,.51.51,0,0,0,.31-.33C9.27,19,10.69,14.16,11,13.24A.51.51,0,0,0,10.74,12.67Z",
        fill: "currentColor"
      }),
      _createElementVNode("path", {
        d: "M3.19,10.16a10,10,0,0,1,3.75-.88,6.4,6.4,0,0,1,3.64,1.32.57.57,0,0,0,.28.08.47.47,0,0,0,.17,0,.53.53,0,0,0,.31-.33l2.07-7.09a.59.59,0,0,0,0-.14h0a.5.5,0,0,0-.24-.43,7.6,7.6,0,0,0-4.4-1.39,11,11,0,0,0-4,.92.5.5,0,0,0-.29.33l-2,7a.51.51,0,0,0,.15.51A.47.47,0,0,0,3.19,10.16Z",
        fill: "currentColor"
      }),
      _createElementVNode("path", {
        d: "M23.83,4.18a.51.51,0,0,0-.53-.08A9.3,9.3,0,0,1,19.57,5a6.55,6.55,0,0,1-4.05-1.34.48.48,0,0,0-.78.25L12.68,11a.61.61,0,0,0,.22.57A8.29,8.29,0,0,0,17.56,13a9.69,9.69,0,0,0,4.11-1,.47.47,0,0,0,.17-.14.45.45,0,0,0,.11-.19l2-7A.51.51,0,0,0,23.83,4.18Z",
        fill: "currentColor"
      })
    ], -1)
  ])))
}
export default { render: render }